jQuery(function($) {
  const $container = $('.realisations-container');
  if (!$container.length) return;

  const $ul = $container.find('ul.realisations');
  if (!$ul.length) return;

  $ul.addClass('swiper-wrapper');
  $ul.children('li').addClass('swiper-slide');

  const $swiperEl = $('<div class="swiper realisations-swiper">');
  $ul.before($swiperEl);
  $swiperEl.append($ul);

  const $nextBtn = $container.find('.next-realisation');
  const $prevBtn = $container.find('.prev-realisation');

  if ($nextBtn.length) $nextBtn.addClass('swiper-button-next-custom');
  if ($prevBtn.length) $prevBtn.addClass('swiper-button-prev-custom');

  new Swiper($swiperEl[0], {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    watchOverflow: false,
    navigation: {
      nextEl: $nextBtn[0] || null,
      prevEl: $prevBtn[0] || null,
      disabledClass: 'swiper-nav-disabled',
    },
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 10 },
      1024: { slidesPerView: 3, spaceBetween: 10 },
    },
  });
});
